var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmcPhoneAppHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.32 63.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e4e4e4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HOME"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.66,
    cy: 31.66,
    r: 31.66
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.04,15.7l-10.87,10.17-2.28,2.13c-.39.37-.73.6-.8,1.17-.09.78,0,1.63,0,2.41v12.06c0,.47.4.87.87.87h10.28c.47,0,.87-.4.87-.87v-5.04c0-1.93-.27-4.91,2.54-4.91s2.54,2.98,2.54,4.91v5.04c0,.47.4.87.87.87h10.28c.47,0,.87-.4.87-.87,0-4.72.12-9.46,0-14.18-.03-1.26-1.51-2.13-2.36-2.93l-6.8-6.36-4.78-4.48c-.82-.77-2.06.47-1.24,1.24,4.56,4.27,9.13,8.54,13.69,12.81l-.26-.62v14.51l.87-.87h-10.28l.87.87v-4.68c0-1.63.26-3.53-.64-4.98-1.43-2.32-4.76-2.7-6.68-.78-1.38,1.38-1.26,3.17-1.26,4.95v5.49l.87-.87h-10.28l.87.87v-14.51l-.26.62c4.56-4.27,9.13-8.54,13.69-12.81.82-.77-.42-2.01-1.24-1.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmcPhoneAppHome2);
export default __webpack_public_path__ + "static/media/MMC_Phone App_Home-2.83e1879f87c14c3c394db6c7b3c990c3.svg";
export { ForwardRef as ReactComponent };